import { Table } from "react-bootstrap";

import { simpleDate, simpleTime } from "../../../utils/displayDate";
import { renderStatus } from "../../../components/transaction/renderBadge";
import { numberWithCommas } from "../../../utils/math";

const TransactionListTable = ({ data }) => {
  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>
              <strong>#</strong>
            </th>
            <th>
              <strong>ວັນທີ່</strong>
            </th>
            <th>
              <strong>ຖອນຈຳນວນ</strong>
            </th>
            <th>
              <strong>ສະຖານະ</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((d, i) => {
            return (
              <tr key={d.id}>
                <td>
                  <strong>{i + 1}</strong>
                </td>
                <td>
                  {simpleDate(d.createdAt)} {simpleTime(d.createdAt)}
                </td>
                <td>{numberWithCommas(d.amount)} ฿</td>
                <td>{renderStatus(d.status)} </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default TransactionListTable;
